import { render } from "./DiscountCampaignEdit.vue?vue&type=template&id=31e3b672"
import script from "./DiscountCampaignEdit.vue?vue&type=script&lang=js"
export * from "./DiscountCampaignEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__